// extracted by mini-css-extract-plugin
export default {"DescriptionWrapper":"Description_DescriptionWrapper__jrsGI"};